<template>
  <div style="height:100%;background:#fff;padding: 10px;">
    <!-- 左侧的显示楼栋列表 -->
    <div>
      <div>
        <el-button type="warning" plain class="el-icon-plus" @click="addBuilding">添加</el-button>
      </div>
      <el-row :gutter="20">
        <el-col style="width: 290px;margin-top:10px" v-for="item in buildListData" :key="item.buildingId">
          <el-card shadow="always" class="card">
            <div class="card_top">
              <i class="el-icon-edit top_icon" @click="infoEdit(item);"></i>
              <i class="el-icon-delete top_icon" @click="infoDelete(item);"></i>
            </div>
            <div class="card_text">
              楼栋名称: <span>{{ item.buildingName }}</span>
            </div>
            <div class="card_text">
              楼栋编号: <span>{{ item.buildingNo }}</span>
            </div>
            <div class="card_text">
              楼层数量: <span>{{ item.floorNum }}</span>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="添加楼栋" :visible.sync="addBuildingVisible" width="600px" :close-on-click-modal="false" center>
      <el-form :model="addBuildingForm" label-width="120px" :rules="addBuildingRules" ref="addBuildingForm">
        <el-form-item label="楼栋名称" prop="buildingName">
          <el-input v-model="addBuildingForm.buildingName" :maxlength="10" auto-complete="off"
            style="width: 374px"></el-input>
        </el-form-item>
        <el-form-item label="楼栋编号" prop="buildingNo">
          <el-input v-model="addBuildingForm.buildingNo" :maxlength="4" auto-complete="off"
            style="width: 374px"></el-input>
        </el-form-item>
        <el-form-item label="楼层数量" prop="floorNum">
          <el-input v-model="addBuildingForm.floorNum" :maxlength="2" @keyup.native="addnumberChange"
            @change="addnumberChange" type="number" auto-complete="off" style="width: 374px" :min="1"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="7">
            <el-form-item label="楼栋楼层连接符" prop="buildLink">
              <el-input v-model="addBuildingForm.buildLink" :maxlength="1" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="楼层房间连接符" prop="floorLink">
              <el-input v-model="addBuildingForm.floorLink" :maxlength="1" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="房间床位连接符" prop="roomLink">
              <el-input v-model="addBuildingForm.roomLink" :maxlength="1" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="床位编号方式" prop="bedNoType">
          <el-select v-model="addBuildingForm.bedNoType" placeholder="请选择" style="width: 374px">
            <el-option v-for="item in bedNoType" :keys="item.value" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否带楼栋编号" prop="isBuildNo">
          <el-select v-model="addBuildingForm.isBuildNo" placeholder="请选择" style="width: 374px">
            <el-option v-for="item in isBuildNo" :keys="item.value" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否带楼层编号" prop="isFloorNo">
          <el-select v-model="addBuildingForm.isFloorNo" placeholder="请选择" style="width: 374px">
            <el-option v-for="item in isBuildNo" :keys="item.value" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="btnLoading" plain
          @click.native="addBuildingSubmit('addBuildingForm');">确定</el-button>
        <el-button plain @click.native="addBuildingVisible = false;">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑楼栋" :visible.sync="editBuildingVisible" width="600px" :close-on-click-modal="false" center>
      <el-form :model="editBuildingForm" label-width="120px" :rules="editBuildRule" ref="addBuildingForm">
        <el-form-item label="楼栋名称" prop="buildingName">
          <el-input v-model="editBuildingForm.buildingName" :maxlength="10" auto-complete="off"
            style="width: 374px"></el-input>
        </el-form-item>
        <el-form-item label="楼栋编号" prop="buildingNo">
          <el-input v-model="editBuildingForm.buildingNo" :maxlength="4" auto-complete="off" readonly
            style="width: 374px"></el-input>
        </el-form-item>
        <el-form-item label="楼层数量" prop="floorNum">
          <el-input v-model="editBuildingForm.floorNum" :maxlength="2" @keyup.native="editnumberChange" readonly
            @change="editnumberChange" type="number" auto-complete="off" style="width: 374px"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="7">
            <el-form-item label="楼栋楼层连接符" prop="buildLink">
              <el-input v-model="editBuildingForm.buildLink" :maxlength="1" auto-complete="off" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="楼层房间连接符" prop="floorLink">
              <el-input v-model="editBuildingForm.floorLink" :maxlength="1" auto-complete="off" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="房间床位连接符" prop="roomLink">
              <el-input v-model="editBuildingForm.roomLink" :maxlength="1" auto-complete="off" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="床位编号方式" prop="bedNoType">
          <el-input readonly :value="editBuildingForm.bedNoType == 1 ? '按房间计数' : '按楼层计数'
            "></el-input>
        </el-form-item>
        <el-form-item label="是否带楼栋编号" prop="isBuildNo">
          <el-input readonly :value="editBuildingForm.isBuildNo == 1 ? '是' : '否'"></el-input>
        </el-form-item>

        <el-form-item label="是否带楼层编号" prop="isFloorNo">
          <el-input readonly :value="editBuildingForm.isFloorNo == 1 ? '是' : '否'"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="btnLoading" plain @click.native="editBuildingSubmit">确定</el-button>
        <el-button plain @click.native="editBuildingVisible = false;">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 查询机构内的房间,根据楼栋楼层来筛选
export default {
  name: "Form",
  data() {
    return {
      layout: JSON.parse(JSON.stringify([])),
      draggable: false,
      resizable: false,
      mirrored: false,
      addBuildLoading: false,
      responsive: false,
      rowHeight: 36,
      colNum: 36,
      saveText: "编辑", //
      showRightView: false, //显示楼栋视图操作
      buildListData: [],
      btnLoading: false,
      addBuildingVisible: false,
      addBuildingForm: {},
      bedNoType: [
        {
          value: 1,
          label: "按房间计数"
        },
        {
          value: 2,
          label: "按楼层计数"
        }
      ],
      isBuildNo: [
        {
          value: 1,
          label: "是"
        },
        {
          value: 2,
          label: "否"
        }
      ],
      addBuildingRules: {
        buildingName: [{ required: true, message: "请输入楼栋名称" }],
        buildingNo: [{ required: true, message: "请输入楼栋编号" }],
        floorNum: [
          { required: true, message: "请输入楼层数量" },
          {
            pattern: /([1-9][0-9]*){1,3}$/,
            message: "楼层不能小于1"
          }
        ],
        bedNoType: [{ required: true, message: "请选择床位编号方式" }],
        isBuildNo: [{ required: true, message: "请选择是否带楼栋编号" }],
        isFloorNo: [{ required: true, message: "请选择是否带楼层编号" }]
      },
      editBuildRule: {
        buildingName: [{ required: true, message: "请输入楼栋名称" }]
      },
      editBuildingVisible: false,
      editBuildingForm: {}
    };
  },
  methods: {
    //获取楼栋列表
    getBuildList() {
      this.$postJson("omc/Building/showAlls").then(res => {
        console.log(res);
        this.buildListData = res.result;
      });
    },
    backList() {
      this.showRightView = false;
    },
    addBuilding() {
      this.addBuildingVisible = true;
      this.addBuildingForm = {
        buildingName: "",
        buildingNo: "",
        floorNum: "",
        buildLink: "",
        floorLink: "",
        roomLink: "",
        bedNoType: "",
        isBuildNo: "",
        isFloorNo: ""
      };
      this.$nextTick(() => {
        this.$refs["addBuildingForm"].resetFields();
      });
    },
    addnumberChange() {
      this.addBuildingForm.floorNum = this.addBuildingForm.floorNum.replace(
        /[^\.\d]/g,
        ""
      );
      this.addBuildingForm.floorNum = this.addBuildingForm.floorNum.replace(
        ".",
        ""
      );
      if (this.addBuildingForm.floorNum.length > 3) {
        this.addBuildingForm.floorNum = this.addBuildingForm.floorNum.substring(
          0,
          3
        );
      }
    },
    editnumberChange() {
      this.editBuildingForm.floorNum = this.editBuildingForm.floorNum.replace(
        /[^\.\d]/g,
        ""
      );
      this.editBuildingForm.floorNum = this.editBuildingForm.floorNum.replace(
        ".",
        ""
      );
      if (this.editBuildingForm.floorNum.length > 3) {
        this.editBuildingForm.floorNum = this.editBuildingForm.floorNum.substring(
          0,
          3
        );
      }
    },
    addBuildingSubmit(formName) {
      if (this.addBuildingForm.buildingName.replace(/\s+/g, "") === "") {
        this.$message.error("楼栋名称不能为空");
        return;
      }
      if (this.addBuildingForm.buildingNo.replace(/\s+/g, "") === "") {
        this.$message.error("楼栋编号不能为空");
        return;
      }
      if (this.addBuildingForm.floorNum.replace(/\s+/g, "") === "") {
        this.$message.error("楼层数不能为空");
        return;
      }
      if (this.addBuildingForm.bedNoType === "") {
        this.$message.error("床位编号方式不能为空");
        return;
      }
      if (this.addBuildingForm.isBuildNo === "") {
        this.$message.error("是否带楼栋编号不能为空");
        return;
      }
      this.btnLoading = true;
      // yang 2020/12/30 添加表单二次校验
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$postForm("omc/Building/addBuilding", this.addBuildingForm).then(
            res => {
              this.btnLoading = false;
              this.getBuildList();
              this.addBuildingVisible = false;
              this.$message.success("添加楼栋成功");
            },
            err => {
              this.btnLoading = false;
              this.$message.error(err.message);
            }
          );
        } else {
          this.btnLoading = false;
          return this.$message.error("请检查红色位置是否填写正确!");
        }
      });
      // this.$post("omc/Building/addBuilding", this.addBuildingForm).then(
      //   res => {
      //     this.btnLoading = false;
      //     this.getBuildList();
      //     this.addBuildingVisible = false;
      //     this.$message.success("添加楼栋成功");
      //   },
      //   err => {
      //     this.btnLoading = false;
      //     this.$message.error(err.message);
      //   }
      // );
    },
    infoEdit(item) {
      this.editBuildingVisible = true;
      this.$nextTick(() => {
        if (this.$refs["editBuildingForm"] != null) {
          this.$refs["editBuildingForm"].clearValidate();
        }
      });
      this.editBuildingForm = Object.assign({}, item);
    },
    editBuildingSubmit() {
      if (this.editBuildingForm.buildingName.replace(/\s+/g, "") === "") {
        this.$message.error("楼栋名称不能为空");
        return;
      }
      this.btnLoading = true;
      var para = {
        buildingId: this.editBuildingForm.buildingId,
        buildingName: this.editBuildingForm.buildingName
      };
      this.$postForm("omc/Building/updateBuilding", para).then(
        res => {
          this.btnLoading = false;
          this.getBuildList();
          this.editBuildingVisible = false;
          this.$message.success("修改成功");
        },
        err => {
          this.btnLoading = false;
          this.$message.error(err.message);
        }
      );
    },
    infoDelete(item) {
      this.$confirm("确认删除该楼栋吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
        center: true
      })
        .then(() => {
          var info = {
            buildingId: item.buildingId
          };
          this.$postForm("omc/Building/delBuildingById", info).then(
            res => {
              this.getBuildList();
              this.$message.success("删除成功");
            },
            err => {
              this.$message.error(err.message);
            }
          );
        })
        .catch(() => { });
    }
  },
  mounted() {
    this.getBuildList();
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.vue-grid-item.cssTransforms {
  background: #1d8ce0;
}

.centertext {
  position: absolute;
  left: 50%;
  top: 50%;
  color: white;
  font-size: 16px;
  transform: translate(-50%, -50%);
}

.box-card {
  font-size: 16px;
}

.el-card__body {
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 0px;
}

.buttontxt {
  width: 49%;
  text-align: center;
  display: inline-block;
  border: 0.5px solid #e4e4e4;
  font-size: 16px;
  padding-bottom: 8px;
  padding-top: 5px;
  cursor: pointer;
}

.card {
  width: 270px;
  border: 1px solid #3a77e2;
  border-radius: 10px;
  padding-bottom: 15px;
}

.card_top {
  background: #3a77e2;
  width: 100%;
  height: 40px;
}

.card ::v-deep .el-card__body {
  padding: 0px;
}

.top_icon {
  float: right;
  color: white;
  font-size: 22px;
  text-align: center;
  margin-top: 9px;
  cursor: pointer;
  margin-right: 10px;
}

.card_text {
  padding-left: 10px;
  font-size: 15px;
  height: 25px;
  padding-top: 5px;
}

//  ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
</style>
